import { createClient } from '@supabase/supabase-js'
import { fencedFetch } from './accountChannel'
import { readStoredRefreshSync } from './localSession'
import { setStoredRefreshReader } from './offline/refreshObserver'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

/**
 * Exported for the one caller that has to address the REST endpoint itself:
 * an RPC whose result must be bound to a specific access token rather than to
 * whatever session the shared client happens to hold when it runs. See
 * lib/emailSubscription.
 */
export const SUPABASE_URL: string | undefined = supabaseUrl
export const SUPABASE_ANON_KEY: string | undefined = supabaseAnonKey

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials not configured — cloud sync disabled')
}

export const supabase = supabaseUrl && supabaseAnonKey
  // fencedFetch: while a peer tab signs this account out, every request this
  // tab starts (auth refresh included) is held until it reloads
  // (src/lib/accountChannel.ts).
  ? createClient(supabaseUrl, supabaseAnonKey, { global: { fetch: fencedFetch } })
  : null

// Refresh answers are bound to the token they refused from the client's very
// first request (offline C2, src/lib/offline/refreshObserver.ts).
if (supabase) setStoredRefreshReader(() => readStoredRefreshSync(supabase))
